import { rem } from 'polished'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { trackClientEvent } from 'analytics/analytics'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import BodyText from 'LuxKit/Typography/BodyText'
import { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import { useTripDocumentUrl } from 'tripPlanner/hooks/api/documents'

const StyledBodyText = styled(BodyText)`
  position: absolute;
  top: 0;
  padding: ${rem(24)};
`

const StyledImage = styled.img`
  position: absolute;
  padding-top: ${rem(72)}; // space for the header content
  padding-bottom: ${rem(12)};
  max-height: calc(100vh);
  object-fit: contain;
`

interface Props {
  documentKey: string
  filename: string
}

function DocumentImageView({ documentKey, filename }: Props) {
  const intl = useIntl()
  const { data: presignedUrl } = useTripDocumentUrl({ documentKey })

  useEffect(() => {
    trackClientEvent({
      action: 'view',
      subject: 'trip_document',
      category: AnalyticsPage.tripPlanner,
      type: 'interaction',
    })
  }, [documentKey])

  return (
    <>
      {!presignedUrl && <LoadingIndicator />}
      {presignedUrl && (
        <>
          <StyledBodyText variant="medium" colour="neutral-eight">
            {filename}
          </StyledBodyText>
          <StyledImage
            src={presignedUrl}
            alt={intl.formatMessage({
              id: 'NcuGpDz7AdDpr_GhzTYM',
              defaultMessage: 'Document',
              description: 'Alt text for a user-uploaded document image in the trip planner',
            })}
            width="100%"
          />
        </>
      )}
    </>
  )
}

export default DocumentImageView
